export enum ApiAccess {
  Trips,
  TripsDefault,
  TripsMetadata,
  TripsItinerary,
  TripsInvoices,
  Expenses,
  WaiversStandAlone,
  WaiversMatching,
  Xx1,
  Receipts,
  Tickets,
  FlightAlerts,
  Enh,
}
